import axios, { CancelToken } from 'axios';
import { getToken } from '../../../token';
import { GATEWAY_API_URL } from '../../../request/urls';

const authHeaders = (): { Authorization?: string } => {
    const token = getToken();
    return token ? { Authorization: `Bearer ${token}` } : {};
};

export type CadastroOpcaoItem = { id: number; nome: string };
export type CadastroCidadeItem = {
    id: number;
    estadoId: number;
    uuid: string;
    nome: string;
    uf: string;
};

class CadastrePublicoFormService {

    private url = GATEWAY_API_URL + '/backend/evento';

    async getVendedores(signal?: CancelToken): Promise<CadastroOpcaoItem[]> {
        const { data } = await axios.get(this.url + '/vendedores', {
            headers: { ...authHeaders() },
            cancelToken: signal,
        });
        return data;
    }

    async getPoderes(signal?: CancelToken): Promise<CadastroOpcaoItem[]> {
        const { data } = await axios.get(this.url + '/poderes', {
            headers: { ...authHeaders() },
            cancelToken: signal,
        });
        return data;
    }

    async getCargos(signal?: CancelToken): Promise<CadastroOpcaoItem[]> {
        const { data } = await axios.get(this.url + '/cargos', {
            headers: { ...authHeaders() },
            cancelToken: signal,
        });
        return data;
    }

    async getCidades(pagina: number, nome: string, signal?: CancelToken): Promise<CadastroCidadeItem[]> {
        const { data } = await axios.get(
            `${this.url}/municipios?pagina=${pagina}&limit=10&nome=${encodeURIComponent(nome)}`,
            {
                headers: { ...authHeaders() },
                cancelToken: signal,
            }
        );
        return data;
    }

    async getUsuarioPorCelular(celular: string, signal?: CancelToken): Promise<string | Record<string, unknown>> {
        const { data } = await axios.get(`${this.url}/celular/${celular}`, {
            headers: { ...authHeaders() },
            cancelToken: signal,
        });
        return data;
    }

    async postCadastroSemContrato(body: Record<string, unknown>, signal?: CancelToken): Promise<unknown> {
        const { data } = await axios.post(this.url + '/usuario', body, {
            headers: { ...authHeaders() },
            cancelToken: signal,
        });
        return data;
    }
}

export default new CadastrePublicoFormService();
